import React from "react";
import { Row, Col, Card, Tag } from "antd";

function OpportunityTooltip(props) {
    console.log(props,"props_opp")
  return (
    <Card>
      <Row>
        <Col>
          <Tag className="success-tag">
            {props.response.Opportunity_tag
              ? props.response.Opportunity_tag
              : ""}
          </Tag>
        </Col>
      </Row>
      <Row span={24}>
        <p>
          {props.response.Opportunity
            ? props.response.Opportunity
            : ""}
        </p>
      </Row>
    </Card>
  );
}
export default OpportunityTooltip;
